import React from 'react';

export default function SuccessPage({ onContinue }) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-10 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-5">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M5 14L11 20L23 8" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Willkommen bei FrameIt!</h1>
        <p className="text-sm text-gray-500 mb-6">Dein Abo wurde aktiviert. Du hast 7 Tage kostenlos – danach beginnt deine Abrechnung.</p>
        <button
          onClick={onContinue}
          className="w-full py-3 bg-indigo-600 text-white text-sm font-semibold rounded-2xl hover:bg-indigo-700 transition-all"
        >
          App öffnen →
        </button>
      </div>
    </div>
  );
}
